import {Stack, Typography} from "@mui/material";
import {memo} from "react";

const SimulationMeta = ({corId, metaData}) => {
  return (
    <Stack spacing={0} textAlign={'center'}>
      <Typography fontSize={'large'} fontFamily={'monospace'} fontWeight={'bolder'} color={'darkred'}>
        SELECTED SIMULATION:
      </Typography>
      <Typography fontSize={'small'} fontFamily={'monospace'} fontWeight={'bold'}>
          {corId && metaData.name ?  metaData.name : 'Fetching Run Metadata...' }
      </Typography>
      <Typography fontSize={'x-small'} fontFamily={'monospace'} fontStyle={'italic'}>
        {corId && metaData.name ?  metaData.one_sentence_summary : ''}
      </Typography >
    </Stack>
  )
}

export default memo(SimulationMeta);